import React from 'react';
import ShieldIcon from '@mui/icons-material/Shield';
export function GuaranteeSection() {
  return <section className="py-8 md:py-12 px-4 bg-white" data-id="element-123">
      <div className="max-w-3xl mx-auto bg-brand-cream rounded-2xl p-5 md:p-8 border-2 border-brand-pink/20 text-center relative overflow-hidden" data-id="element-124">
        <div className="absolute -right-10 -top-10 text-brand-pink/5" data-id="element-125">
          <ShieldIcon style={{
          fontSize: 160
        }} data-id="element-126" />
        </div>

        <div className="relative z-10" data-id="element-127">
          <ShieldIcon className="text-brand-pink mb-2" style={{
          fontSize: 48
        }} data-id="element-128" />
          <h2 className="font-heading text-xl md:text-2xl font-bold text-brand-dark mb-3" data-id="element-129">
            🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
          </h2>

          <div className="text-base text-brand-text space-y-1 mb-4 font-medium" data-id="element-130">
            <p data-id="element-131">Entrás al sistema.</p>
            <p data-id="element-132">Leés los tomos.</p>
            <p data-id="element-133">Aplicás el método.</p>
          </div>

          <p className="text-base md:text-lg font-bold text-brand-dark mb-3" data-id="element-134">
            Y si sentís que no era lo que esperabas:
          </p>

          <div className="bg-white rounded-xl p-4 shadow-sm border border-brand-pink/10 inline-block" data-id="element-135">
            <p className="text-lg md:text-xl font-black text-brand-pink mb-1" data-id="element-136">
              Te devolvemos el 100% de tu dinero.
            </p>
            <p className="text-brand-text font-medium text-sm" data-id="element-137">Sin vueltas.</p>
            <p className="text-brand-text font-medium text-sm" data-id="element-138">
              Sin formularios complicados.
            </p>
          </div>

          <p className="mt-4 font-bold text-brand-purple text-lg" data-id="element-139">
            El riesgo es nuestro.
          </p>
        </div>
      </div>
    </section>;
}